/* LittleG Tool 05 — 1–8 explicitly non-overlapping rectangular floor zones.
 * No property saleable-area inference, certified plan, cloud storage or billing.
 */
(function(global){
  'use strict';
  const SQFT_PER_SQM=10.763910416709722;
  const positive=raw=>{
    if(raw===''||raw===null||raw===undefined)return null;
    const n=Number(raw);
    return Number.isFinite(n)&&n>0&&n<=10000?n:null;
  };
  const display=n=>Math.round((n+Number.EPSILON)*100)/100;
  function assessRoom(rectangles,excludeInput=''){
    if(!Array.isArray(rectangles)||rectangles.length<1||rectangles.length>8)return null;
    let gross=0;
    for(const rectangle of rectangles){
      if(!rectangle||typeof rectangle!=='object'||Array.isArray(rectangle))return null;
      const length=positive(rectangle.length),width=positive(rectangle.width);
      if(length===null||width===null)return null;
      gross+=length*width;
      if(!Number.isFinite(gross)||gross>1e8)return null;
    }
    const blank=excludeInput===''||excludeInput===undefined||excludeInput===null;
    const excluded=blank?0:Number(excludeInput);
    if(!Number.isFinite(excluded)||excluded<0||excluded>=gross)return null;
    const net=gross-excluded;
    return{
      contract:'littleg_room_floor_estimate_v1',
      rectangles:rectangles.length,
      gross_m2:display(gross),
      excluded_m2:display(excluded),
      usable_estimate_m2:display(net),
      usable_estimate_sqft:display(net*SQFT_PER_SQM),
      rectangles_verified_nonoverlap:false,
      official_saleable_area:false,
      professional_measurement:false
    };
  }
  if(typeof module!=='undefined'&&module.exports)module.exports={assessRoom};
  if(!global.document)return;
  const fmt=n=>new Intl.NumberFormat(undefined,{maximumFractionDigits:2}).format(n);
  global.document.querySelectorAll('[data-littleg-room-tool]').forEach(form=>{
    const rows=form.querySelector('[data-room-rows]');
    const template=form.querySelector('template[data-room-template]');
    const add=form.querySelector('[data-room-add]');
    const exclude=form.querySelector('[data-room-exclude]');
    const headline=form.querySelector('[data-room-headline]');
    const output=form.querySelector('[data-room-result]');
    const container=form.querySelector('[data-room-result-container]');
    if(!rows||!template||!add||!exclude||!headline||!output||!container)return;
    const zh=form.dataset.roomLocale!=='en';
    const allRows=()=>[...rows.querySelectorAll('[data-room-row]')];
    function refreshRowLabels(){
      const list=allRows();
      list.forEach((row,i)=>{
        const title=row.querySelector('[data-room-row-title]');
        if(title)title.textContent=(zh?'矩形 ':'Rectangle ')+(i+1);
        const remove=row.querySelector('[data-room-remove]');
        if(remove)remove.disabled=list.length<=1;
      });
      add.disabled=list.length>=8;
    }
    function render(){
      const all=allRows();
      const rectangles=all.map(row=>({
        length:row.querySelector('[data-room-length]')?.value.trim()||'',
        width:row.querySelector('[data-room-width]')?.value.trim()||''
      }));
      if(rectangles.some(rect=>rect.length===''||rect.width==='')){
        container.dataset.state='idle';
        headline.textContent=zh?'請填寫各塊矩形的長與闊':'Enter length and width for each rectangle';
        output.textContent=zh?'完成輸入後會顯示平方米和平方呎。':'Square metres and square feet appear after all fields are filled.';
        return;
      }
      const result=assessRoom(rectangles,exclude.value.trim());
      if(!result){
        container.dataset.state='invalid';
        headline.textContent=zh?'請核對面積資料':'Review the room dimensions';
        output.textContent=zh?'長闊必須大於 0，扣除面積不得等於或超過總面積，最多 8 塊矩形。':'All dimensions must be positive; exclusions must be smaller than gross area. Maximum eight rectangles.';
        return;
      }
      container.dataset.state='ready';
      headline.textContent=fmt(result.usable_estimate_m2)+' m²  /  '+fmt(result.usable_estimate_sqft)+' sq ft';
      output.textContent=(zh?'合計 '+result.rectangles+' 塊矩形；總面積 ':'Total from '+result.rectangles+' rectangles: ')+
        fmt(result.gross_m2)+' m²'+
        (result.excluded_m2>0?(zh?'；已扣除 ':'; excluded ')+fmt(result.excluded_m2)+' m²':'')+
        (zh?'。請確保各塊沒有重疊。':'. Do not count overlapping floor zones twice.');
    }
    add.addEventListener('click',()=>{
      if(allRows().length>=8)return;
      const clone=template.content.firstElementChild?.cloneNode(true);
      if(!clone)return;
      rows.append(clone);
      refreshRowLabels();render();
      const first=clone.querySelector('[data-room-length]');
      if(first&&typeof first.focus==='function')first.focus({preventScroll:true});
    });
    rows.addEventListener('click',event=>{
      const button=event.target.closest('[data-room-remove]');
      if(!button||!rows.contains(button)||button.disabled)return;
      const row=button.closest('[data-room-row]');
      if(row&&allRows().length>1){row.remove();refreshRowLabels();render();}
    });
    form.addEventListener('input',render);
    form.addEventListener('change',render);
    form.addEventListener('submit',event=>{event.preventDefault();render();});
    refreshRowLabels();render();
  });
})(typeof window==='undefined'?globalThis:window);
